import React from 'react';
import ReactGA from 'react-ga';
import Article from '../Article';
import Banner from '../Banner';

function initializeGA(){
    ReactGA.initialize('UA-144557614-1');
    ReactGA.pageview('/home')
}

class MainPage extends React.Component {

    constructor(props){
        super(props);
        this.data = this.props.info;
    }

    componentDidMount(){
        initializeGA();
    }

    render(){


        return ( 
            <div>
                
                <Banner 
                    backgroundImage="url(assets/img/bg-apt.jpg)"
                    title="Ótimos apartamentos para você e sua família"
                    subTitle="Entre em contato para melhores preços e condições!"
                />
    
                <main className="main-content bg-gray">
                        <Article data={this.data}/>
                </main>
    
            </div>
    
            
      );



    }
   
   
  
}

export default MainPage;


// WEBPACK FOOTER //
// ./src/common/MainPage/index.jsx